import { render, staticRenderFns } from "./TaskManagementTable.vue?vue&type=template&id=b3a36578&"
import script from "./TaskManagementTable.vue?vue&type=script&lang=js&"
export * from "./TaskManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports